/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {ContinuingMedicalEducationInformation} from './continuing-medical-education-information.model';
import {UserModelService} from '../../common/user-model.service';

@Injectable()
export class ContinuingMedicalEducationInformationService extends UserModelService<ContinuingMedicalEducationInformation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'continuingMedicalEducationInfo', ContinuingMedicalEducationInformation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/cme/continuing-medical-education-information.service.ts